<div class="wrapper" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
  <mat-form-field>
    <input #input type="text" matInput (input)="_filter(input)" (focus)="_filter(input)" [name]="inputName" [matAutocomplete]="auto" />
    <mat-autocomplete #auto="matAutocomplete" [classList]="panelClass" [displayWith]="displayAutoCompleteValue" (optionSelected)="optionSelected($event)">
      @for (option of filteredOptions; track $any(option)[idKey]) {
        <mat-option [value]="option">{{ displayAutoCompleteValue(option) }}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</div>
